import React from 'react';

const AdPlaceholder = ({ style }: { style?: React.CSSProperties }) => (
  <div
    role="ad-placeholder"
    style={{
      ...style,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      minHeight: style && style.minHeight ? style.minHeight : undefined,
      minWidth: style && style.minWidth ? style.minWidth : undefined,
      background: 'repeating-linear-gradient(135deg, #f8fafc, #f8fafc 20px, #e0e7ef 20px, #e0e7ef 40px)',
      border: '1px dashed #e5e7eb',
      color: '#94a3b8',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: 8,
      boxSizing: 'border-box',
    }}
  >
    <span style={{ fontSize: 14, color: '#94a3b8', zIndex: 1, fontWeight: 500, letterSpacing: 1 }}>Advertisement</span>
    <span
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(90deg, #f8fafc 25%, #e0e7ef 50%, #f8fafc 75%)',
        opacity: 0.4,
        animation: 'ad-placeholder-shimmer 1.5s infinite',
        zIndex: 0,
      }}
    />
    <style>{`
      @keyframes ad-placeholder-shimmer {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
      div[role="ad-placeholder"] > span[style*="absolute"] {
        will-change: transform;
      }
    `}</style>
  </div>
);

export default AdPlaceholder;
